import * as React from 'react';
import MuiAppBar  from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Button from '@mui/material/Button';
import { useAuth } from '../modules/auth/AuthContext';
import useConfig from '../core/useConfig';

export default function AppBar() {
  const {logout} = useAuth()
  const {viewer} = useConfig()
  return (
    <Box sx={{ flexGrow: 1 }}>
      <MuiAppBar position="static">
        <Toolbar sx={{flexDirection:'row-reverse'}}>
          <Button sx={{color:'white'}} onClick={()=>logout(viewer?.id!)}>Logout</Button>
        </Toolbar>
      </MuiAppBar>
    </Box>
  );
}
